import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Configure toast globally (only call this once in your main App component)
export const setupToast = () => {
  toast.configure({
    position: "top-left", // Position of the toast stack
    autoClose: 3000, // Time before auto-close (3s)
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "dark", // Light/Dark/Colored themes available
  });
};

// Function to show a success message
export const showSuccessToast = (message) => {
  toast.success(message);
};

// Function to show an error message
export const showErrorToast = (message) => {
  toast.error(message);
};

// Function to show an info message
export const showInfoToast = (message) => {
  toast.info(message);
};

// Function to show a warning message
export const showWarningToast = (message) => {
  toast.warn(message);
};
